import { typeEnvironment } from '@/utilities/constants';
const SERVICE = {
    development: 'https://sms-api-dev.otocrm.com.br',
    hmg: 'https://sms-api-hmg.otocrm.com.br',
    production: 'https://sms-api.otocrm.com.br',
};
export function getServiceBase() {
    const env = typeEnvironment;
    return SERVICE[env];
}
